import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  toasts: []
};

const toasterSlice = createSlice({
  name: "toaster",
  initialState,
  reducers: {
    showToast: (state, action) => {
      state.toasts.push(action.payload);
    },
    removeToast: (state) => {
      state.toasts.shift();
    }
  }
});

export const { showToast, removeToast } = toasterSlice.actions;
export default toasterSlice.reducer;
